import {
  BUTLER_ZYZT, maritalStatus, medical_status, moudleType, ORDER_STATUS, SCHEME_STATUS, USER_TYPE, weekArr
} from "./config";
import timeF from "lmw-time-format"
//time为时间戳格式，如"1487555260448"
const Todate = (time) => {
  let now = new Date(time)
  let mm = now.getMonth() + 1     //月
  let dd = now.getDate()          //日
  let hh = now.getHours()        //
  let ii = now.getMinutes()      //分
  let clock = ''

  if (mm < 10) clock += "0"
  clock += mm + "-"
  if (dd < 10) clock += "0"
  clock += dd + " "
  if (hh < 10) clock += "0"
  clock += hh + ":"
  if (ii < 10) clock += "0"
  clock += ii
  return clock
}
//time为datetime格式，如"2017-02-03 00:00:00"
const Getdate = (time) => {
  let now = new Date(time)
  let year = now.getFullYear()
  let mm = now.getMonth() + 1     //月
  let dd = now.getDate()          //日
  let hh = now.getHours()        //时
  let ii = now.getMinutes()      //分
  let clock = ''
  clock += year + '-'
  if (mm < 10) clock += "0"
  clock += mm + "-"
  if (dd < 10) clock += "0"
  clock += dd + " "
  if (hh < 10) clock += "0"
  clock += hh + ":"
  if (ii < 10) clock += "0"
  clock += ii
  return clock
}
//time为datetime格式，如"2017-02-03 00:00:00"

const getWeek = (time) => {
  time = new Date(time)
  let year = time.getFullYear()
  let month = time.getMonth()
  let day = time.getDate()
  let week = new Date(year, month, day).getDay()
  if (week == 0) return '周日'
  if (week == 1) return '周一'
  if (week == 2) return '周二'
  if (week == 3) return '周三'
  if (week == 4) return '周四'
  if (week == 5) return '周五'
  if (week == 6) return '周六'
}
//time为datetime格式，如"2017-02-03 00:00:00"
const getDay = (time) => {
  time = new Date(time)
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let day = time.getDate()
  return year + '年' + month + '月' + day + '日'
}
const getMyDay = (oldTime) => {
  var time = oldTime;
  if (typeof (oldTime) == 'string') {
    time = oldTime.replace(/\-/g, "/");
  }
  let date = new Date(time);
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + (date.getDate())).slice(-2);
  let year = date.getFullYear();
  return Number(year) + "-" + (month) + "-" + (day);
}
const goodTime = function (unixTime) {

  if (!unixTime) {
    return "";
  }

  let str = parseInt(unixTime)
  var now = new Date().getTime(), oldTime = new Date(str).getTime(), difference = now - oldTime, result = '',
    minute = 1000 * 60, hour = minute * 60, day = hour * 24, halfamonth = day * 15, month = day * 30, year = month * 12,

    _year = difference / year, _month = difference / month, _week = difference / (7 * day), _day = difference / day,
    _hour = difference / hour, _min = difference / minute;
  if (_year >= 1) {
    result = ~~(_year) + " 年前"
  } else if (_month >= 1) {
    result = ~~(_month) + " 个月前"
  } else if (_week >= 1) {
    result = ~~(_week) + " 周前"
  } else if (_day >= 1) {
    result = ~~(_day) + " 天前"
  } else if (_hour >= 1) {
    result = ~~(_hour) + " 个小时前"
  } else if (_min >= 1) {
    result = ~~(_min) + " 分钟前"
  } else result = "刚刚";
  return result;
}
const getAge = function (id) {
  if (!id) {
    return "";
  }

  let birthday, now, age;
  now = timeF(Date.now(), '%Y%m%d');
  if (id.length === 18) {
    birthday = id.substr(6, 8);
  } else if (id.length === 15) {
    birthday = id.substr(6, 6);
    birthday = '19' + birthday;
  } else {
    return '';
  }
  age = parseInt(now) - parseInt(birthday);
  return parseInt(age / 10000);
}
const getSex = function (id) {
  if (!id) return '';
  let char;
  if (id.length === 18) {
    char = id.substring(16, 17);
    if (isNaN(char)) return;
    char = parseInt(char);
    return char % 2 === 1 ? '男' : '女'
  }
  return ''
}
const getGender = function (str) {
  if (!str) {
    return "";
  }
  str = str.toLowerCase();
  let sex = {
    m: '男', f: '女', n: '未知'
  }
  return sex[str] ? sex[str] : sex.n
}
const week = function (item) {
  var date = ""
  if (isNaN(item)) return item;
  item = parseInt(item);
  switch (item) {
    case 1:
      date = "一";
      break;
    case 2:
      date = "二";
      break;
    case 3:
      date = "三";
      break;
    case 4:
      date = "四";
      break;
    case 5:
      date = "五";
      break;
    case 6:
      date = "六";
      break;
    case 7:
      date = "日";
      break;
  }
  return date
}
const filterGetWeek = function (str, prev = '周') {
  if (str === undefined || str === '') return '';
  return prev + weekArr[str];
};
const isAuth = function (isRealnameAuth) {
  return isRealnameAuth ? "已认证" : "未认证"
}
/**
 * 脱敏处理
 * @param str
 * @param startLength
 * @param endLeng
 * @param hiddenLeng
 * @returns {string}
 */
const formatCardAndMobile = function (str, startLength, endLeng, hiddenLeng) {
  if (!str) {
    return ""
  }
  let hiddenStr = "";
  for (let i = 0; i < hiddenLeng; i++) {
    hiddenStr += "*"
  }
  return str.substr(0, startLength) + hiddenStr + (endLeng ? str.substr(0 - endLeng) : '');
}


/**
 * 脱敏处理，姓名
 * @param str
 * @returns {string|*}
 */
const hidderName = (str) => {
  if (!str) return str;
  let l = str.length;
  return formatCardAndMobile(str, 1, 0, l - 1);
}

/**
 * 脱敏处理，身份证
 * @param str
 * @returns {string|*}
 */
const hidderCard = (str, startLength = 6, endLength = 4) => {
  if (!str) return str;
  let l = str.length;
  return formatCardAndMobile(str, startLength, endLength, l - startLength - endLength);
}

/**
 * 脱敏处理，手机号
 * @param str
 * @returns {string|*}
 */
const hidderMobile = (str) => {
  if (!str) return str;
  let l = str.length;
  return formatCardAndMobile(str, 3, 4, l - 7);
}
/**
 * 价格格式化
 * @param str
 * @returns {string}
 */
const formatPrice = function (str, options) {
  if ((options && options.open === false) || (options && options.name == 'book')) {
    return "";
  }
  if (!str) {
    str = "0.0";
  }
  return "￥" + str;
}
/**
 * 时间
 * @param str
 * @param format
 */
const formatTime = function (str, format) {
  if (!str) return '';
  return timeF(parseInt(str), format);
}
/**
 * 订单状态
 * @param str
 * @returns {string}
 */
const getOrderStatus = function (str, registeType) {
  let ret = ORDER_STATUS[str] ? ORDER_STATUS[str] : '';
  if (ret == '已预约' && registeType && registeType == 2) {
    ret = '已挂号'
  }
  return ret;
}

const getOrderAmpm = function (str) {
  if (!str) return "";
  if (['am', 'pm', 'ni', "AM", "PM", 'NI'].includes(str))
    return str.toLowerCase() == "am" ? "上午" :
      str.toLowerCase() == "pm" ? "下午" :
        "延时（17:00-20:00）";
  if (['1', '2'].includes(str)) {
    return schoolBookAmpmFilter(str);
  }
  return str;
}

/**
 * 就诊预估时间
 */
const numTime = function (str) {
  if (!str) return '';
  if (str.length === 5) return str;
  const time = str.substr(11, 5);
  if (time === '00:00') return '';
  else return time;
}

const filterHTML = function (str) {
  return str.replace(/style="([^"]+?)"/g, '')
}

const delHtmlTag = (str) => {
  return str.replace(/<[^>]+>/g, "");//去掉所有的html标记
}

const formatScore = (str) => {
  if (Math.round(str) == str) {
    return `${str}.0`
  }
  return str;
}

const schemeStatus = (res) => {
  return SCHEME_STATUS[res] || '';
}

const splitTime = (res) => {
  if (!res) return "";
  return res.substr(0, 4) + "-" + res.substr(4, 2) + "-" + res.substr(6);
}

const TijianxjToHtml = (res) => {
  if (!res) return "";
  /*res = res.replace(/\r/g, res => `<br/>`)
  res = res.replace(/[\d]+[.、](.+?)[:]{1}/g, s => `<h5>${s}</h5><p>`);
  res = res.replace(/[↑↓]{1}/g, s => `<font class="red">${s}</font>`);*/

  let str = "";
  for (let re of res) {
    Log('---re---', re);
    re = re.replace(/:/g, s => `<h5>${s}</h5><p>`);
    re = re.replace(/[↑↓]{1}/g, s => `<font class="red">${s}</font>`);
    str += re;
  }
  return str;
}

const TijianxjsToHtml = (res) => {
  if (!res) return "";
  /*res = res.replace(/\r/g, res => `<br/>`)
  res = res.replace(/[\d]+[.、](.+?)[:]{1}/g, s => `<h5>${s}</h5><p>`);
  res = res.replace(/[↑↓]{1}/g, s => `<font class="red">${s}</font>`);*/

  let str = "";
  for (let re of res) {
    Log('---re---', re);
    let temp = re.split(/[:：]/);
    Log('-------------temp------------', temp);
    let [f, ...c] = temp;
    re = `<h5>${f}</h5><p>${c.join('')}</p>`;
    // re = re.replace(/[\d]+[.、](.+?)[:：]{1}/g, s => `<h5>${s}</h5><p>`);
    re = re.replace(/[↑↓]{1}/g, s => `<font class="red">${s}</font>`);
    str += re;
  }
  return str;
}

const TijianyjsToHtml = (res) => {
  if (!res) return "";
  /*res = res.replace(/\r/g, res => `<br/>`)
  res = res.replace(/[\d]+[.、](.+?)[:]{1}/g, s => `<h5>${s}</h5><p>`);
  res = res.replace(/[↑↓]{1}/g, s => `<font class="red">${s}</font>`);*/

  let str = "";
  for (let re of res) {
    Log('---re---', re);
    let temp = re.split(/[:：\r\n]/);
    Log('-------------temp------------', temp);
    let [f, ...c] = temp;
    re = `<h5>${f}</h5><p>${c.join('')}</p>`;
    // re = re.replace(/[\d]+[.、](.+?)[:：]{1}/g, s => `<h5>${s}</h5><p>`);
    re = re.replace(/[↑↓]{1}/g, s => `<font class="red">${s}</font>`);
    str += re;
  }
  return str;
}

const TijianzdToHtml = (res) => {
  if (!res) return "";
  res = res.replace(/[ ]+/g, s => new Array(s.length).fill("&nbsp;").join(""));
  res = res.replace(/[\r\n]/g, s => `<br/>`);
  return res;
}

const filter_report_shenheeq = (res) => {
  console.log('time', res);
  if (!res) return "";
  if (res.length < 10) {
    res = splitTime(res);
  } else {
    res = res.substr(0, 10);
  }
  return res;
}
/**
 * 简单截取字符串
 * @param str
 * @param length
 * @param fix
 * @returns {string}
 */
const str_substr = (str, length, fix = true) => {
  if (!str) return "";
  return str.length <= length ? str : str.substr(0, length) + (fix ? '...' : '');
}

const filterConsultPrice = (str) => {
  if (!str) return "";
  if (typeof str === "string") return "";
  if (Object.keys(str).length === 0) return "";
  let price = str.hasOwnProperty('consultPrice') ? str.consultPrice : str.docPicConsultPrice,
    limit = str.consultCanReplyNumber;
  if (limit > 0) {
    return '￥' + price + '/' + limit + '条';
  } else return '￥' + price;
}

const getMedicalOrderStatus = (str, field) => {
  if (!str) return "";
  const status = medical_status.find(r => r.id == str);
  if (!status) return '';
  if (field) return status[field];
  return status;
}

const comboPrice = (str, delta = 100, prefix = '￥') => {
  if (str === undefined) return "";
  str = parseFloat(str) || 0;
  if (delta)
    str = parseFloat(str / delta);
  return prefix + str.toFixed(2);
}

/**
 * 婚姻状态
 * @param str
 * @returns {string}
 */
const getMaritalStatus = (str) => {
  if (!str) return '';
  return maritalStatus[str];
};
/**
 * 咨询类型
 * @param str
 * @returns {string|*}
 */
const getMoudleType = (str) => {
  if (!str) return '';
  return moudleType[str] || str;
};

const butlerZyztFilter = (str) => {
  if (!str) return "";
  return BUTLER_ZYZT[str] || str
}

/**
 * 群聊会话页时间格式化
 * @param str
 */
const replyTime = (str) => {
  if (!str) return;
  let ans = '';
  const now = Date.now();
  const format = ['%Y-%m-%d', '%p', '%H:%M', '%Y-%m-%d %H:%M:%S'];
  const today = timeF(now, format[0]);
  const replyDay = timeF(str, format[0]);
  let delta = now - str;
  //1分钟内
  if (delta <= 60 * 1000) {
    return '刚刚';
  }
  //1小时内
  if (delta <= 60 * 60 * 1000) {
    return Math.floor(delta / 60 / 1000) + '分钟前';
  }
  //一天内
  if (today === replyDay) {
    ans = timeF(str, format[1]) === 'AM' ? '上午' : '下午'
    return ans + ' ' + timeF(str, format[2]);
  }
  //一天以上
  return timeF(str, format[3])
}

/**
 * 用户类型
 * @param str
 * @returns {*}
 */
const userTypeFilter = (str) => {
  if (!str) return str;
  return USER_TYPE[str] || str;
}

const wrapURLFilter = (str) => {
  if (!str) return str;
  const reg = new RegExp('(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]', 'g');
  return str.replace(reg, `<a href="$&">$&</a>`)
}

const schoolBookStateFilter = str => {
  if (!str) return str;
  return ['', '预约', '已满', '停诊'][str];
}

const schoolBookAmpmFilter = str => {
  if (!str) return str;
  return ['', '上午', '下午', '晚上'][str];
}

const schoolBookOrderStatusFilter = str => {
  if (!str) return str;
  if (str == 1) return '预约成功'
  if (str == 2) return '失败'
  if (str == -1) return '已取消'
  return `未知${str}`
}

const bookFeeFilter = (str) => {
  if (!str) return '￥0';
  return '￥' + parseFloat(str).toFixed(2);
}

/**
 * 缩短医院简称
 * @param str
 * @returns {*}
 */
const shortHosName = str => {
  if (!str) return;
  return str.replace("浙江大学医学院附属第二医院", "浙大二院");
}

export {
  shortHosName,
  schoolBookAmpmFilter,
  schoolBookStateFilter,
  schoolBookOrderStatusFilter,
  userTypeFilter,
  Todate,
  getWeek,
  getDay,
  goodTime,
  getMyDay,
  getAge,
  getSex,
  getGender,
  Getdate,
  week,
  filterGetWeek,
  isAuth,
  formatCardAndMobile,
  formatPrice,
  formatTime,
  getOrderStatus,
  splitTime,
  TijianxjToHtml,
  TijianzdToHtml,
  filter_report_shenheeq,
  getOrderAmpm,
  filterHTML,
  formatScore,
  delHtmlTag,
  schemeStatus,
  str_substr,
  filterConsultPrice,
  getMedicalOrderStatus,
  comboPrice,
  getMaritalStatus,
  getMoudleType,
  butlerZyztFilter,
  replyTime,
  wrapURLFilter,
  hidderName,
  hidderCard,
  hidderMobile,
  TijianxjsToHtml,
  TijianyjsToHtml,
  numTime,
  bookFeeFilter
}




// WEBPACK FOOTER //
// ./src/lib/filter.js